import React from "react";

const CorporateIdentity = () => {
  return (
    <div className='main-container'>
      <h1 className='title'>Our Corporate Identity</h1>
      <div className='description'>
        Our corporate policy is to guarantee affordability, personalized service
        and prompt payment of the medica charges of our covered member bills and
        to rapidly gain unqualified acceptance by and among members of the
        working class as well as the best healthcare providers in the country at
        the same time ensuring its place in an industry that is still in its
        infancy. Through this policy, we hope to touch the lives of Filipino
        families everywhere, especially the most needy.
      </div>
      <h1 className='title'>Our Corporate Values</h1>
      <div className='description'>
        <div className='table'>
          <div className='row row-1'>
            <div className='row-title'>Goal Oriented</div>
            <div className='row-text'>
              Focused and responsible in achieving company goals and objectives
              at all times.
            </div>
          </div>
          <div className='row row-2'>
            <div className='row-title'>Excellence</div>
            <div className='row-text'>
              Committed to deliver to our members the highest quality of service
              at all times and to do our best in exceeding their expectations.
            </div>
          </div>
          <div className='row row-3'>
            <div className='row-title'>Teamwork</div>
            <div className='row-text'>
              Committed to work as one family in a spirit of cooperation, mutual
              respect and trust.
            </div>
          </div>
          <div className='row row-3'>
            <div className='row-title'>Willingness</div>
            <div className='row-text'>
              to uphold the fundamental principles of integrity, honesty,
              fairness, transparency, hard work and enduring sense of humanity.
            </div>
          </div>
          <div className='row row-3'>
            <div className='row-title'>Efficient</div>
            <div className='row-text'>
              Committed to do whatever it takes to get the job done immediately,
              properly and on time.
            </div>
          </div>
          <div className='row row-3'>
            <div className='row-title'>Loyal</div>
            <div className='row-text'>
              We love our company, our members and the group and willstanby it's
              principle and will defend it at all times.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorporateIdentity;
